import KissHer from './kissHer.js';
import HerKiss from './herKiss.js';
import Epilog from './epilog.js';

export default [
    {
        backgroundImg: `assets/bgImgs/black.webp`,
        speakerName: `unset`,
        characterImg: `unset`,
        speakerTxt: `[In front of Millie and Anna's house ...]`,
        speakerTxtRS: `[Ispred Milicine i Anine kuće ...]`
    },
    {
        backgroundImg: `assets/bgImgs/house.webp`,
        speakerName: `Anna Adams`,
        speakerNameRS: `Ana Adamović`,
        characterImg: `assets/chars/anna/openSmileBlushCasual.webp`,
        speakerTxt: `"Well, it's getting pretty late. I should probably head in."`,
        speakerTxtRS: `"Pa, postaje prilično kasno. Verovatno bi trebalo da krenem unutra."`,
        dialogFx: `assets/dialog/anna/anna0037.mp3`
    },
    {
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        speakerTxt: `"Yeah, me too. I had a great time tonight."`,
        speakerTxtRS: `"Da, i ja. Lepo sam se proveo večeras."`,
        dialogFx: `assets/dialog/joseph/joseph0100.mp3`
    },
    {
        speakerName: `Anna Adams`,
        speakerNameRS: `Ana Adamović`,
        speakerTxt: `"Me too. I'm really glad we got to spend some time together."`,
        speakerTxtRS: `"I ja. Stvarno mi je drago što smo se proveli vreme zajedno."`,
        dialogFx: `assets/dialog/anna/anna0038.mp3`
    },
    {
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        characterImg: `assets/chars/anna/closedSmileCasual.webp`,
        speakerTxt: `She is staring so intently at me.`,
        speakerTxtRS: `Ona me tako pomno gleda.`,
        dialogFx: `assets/dialog/joseph/joseph0101.mp3`
    },
    {
        speakerName: `unset`,
        choicesBtns: [
            `Kiss her`,
            `Do nothing`,
        ],
        choicesBtnsRS: [
            `Poljubi je`,
            `Uradi ništa`,
        ],
        appendNextStoryParts: [
            [KissHer, Epilog],
            [HerKiss, Epilog]
        ]
    }
]